const actions = {

    AUDIT_MODULE_TOGGLE_AUDITS_DRAWER: 'AUDIT_MODULE_TOGGLE_AUDITS_DRAWER',
    AUDIT_MODULE_SET_NAME: 'AUDIT_MODULE_SET_NAME',

    AUDIT_MODULE_SET_ID: 'AUDIT_MODULE_SET_ID',

    AUDIT_MODULE_READ_ALL_REQUEST: 'AUDIT_MODULE_READ_ALL_REQUEST',
    AUDIT_MODULE_READ_ALL_SUCCESS: 'AUDIT_MODULE_READ_ALL_SUCCESS',
    AUDIT_MODULE_READ_ALL_ERROR: 'AUDIT_MODULE_READ_ALL_ERROR',

    AUDIT_MODULE_READ_REQUEST: 'AUDIT_MODULE_READ_REQUEST',
    AUDIT_MODULE_READ_SUCCESS: 'AUDIT_MODULE_READ_SUCCESS',
    AUDIT_MODULE_READ_ERROR: 'AUDIT_MODULE_READ_ERROR',

    AUDIT_MODULE_RESET_STATE: 'AUDIT_MODULE_RESET_STATE',
    AUDIT_MODULE_RESET_AUDIT: 'AUDIT_MODULE_RESET_AUDIT',
    AUDIT_MODULE_RESET_ID: 'AUDIT_MODULE_RESET_ID',

    // --------------------- General Audit (Applies to all reducer states) --------------------------- //
    toggleAuditsDrawer: (auditName, open) => ({
        type: actions.AUDIT_MODULE_TOGGLE_AUDITS_DRAWER,
        auditName,
        auditsDrawerOpen: open,
    }),

    setAuditName: auditName => ({
        type: actions.AUDIT_MODULE_SET_NAME,
        auditName,
    }),

    // --------------------- Specific Audit Module (AuditName.ACCOUNT, AuditName.CONTACT, AuditName.PRODUCT, ...) --------------------------- //
    setAuditId: (id, auditName) => ({
        type: actions.AUDIT_MODULE_SET_ID,
        auditName,
        id,
    }),

    readAudits: (id, auditName, request) => ({
        type: actions.AUDIT_MODULE_READ_ALL_REQUEST,
        id,
        auditName,
        request,
    }),
    readAudit: (id, auditName, logId) => ({
        type: actions.AUDIT_MODULE_READ_REQUEST,
        id,
        auditName,
        logId,
    }),
    resetAuditState: auditName => ({
        type: actions.AUDIT_MODULE_RESET_STATE,
        auditName,
    }),
    resetAudit: auditName => ({
        type: actions.AUDIT_MODULE_RESET_AUDIT,
        auditName,
    }),
    resetAuditId: auditName => ({
        type: actions.AUDIT_MODULE_RESET_ID,
        auditName,
    }),

    withAuditName: auditName => ({
        // GENERAL
        toggleAuditsDrawer: open => actions.toggleAuditsDrawer(auditName, open),
        setAuditName: () => actions.setAuditName(auditName),
        // SPECIFIC
        setAuditId: id => actions.setAuditId(id, auditName),
        readAudits: (id, request) => actions.readAudits(id, auditName, request),
        readAudit: (id, logId) => actions.readAudit(id, auditName, logId),
        resetAuditState: () => actions.resetAuditState(auditName),
        resetAudit: () => actions.resetAudit(auditName),
        resetAuditId: () => actions.resetAuditId(auditName),
    }),

};

export default actions;
